const CURRENT_VENUE_ID_KEY = 'currentVenueID';

// Draft/form state is scoped to a single venue and must not leak across profiles
const VENUE_SCOPED_STORAGE_KEYS = [
  'collabReducer',
  'collab-search-text',
  'product-form-data',
  'product-form-step',
  'offer-form-data',
  'offer-form-step',
];

export const getCurrentVenueID = (): string | null =>
  window.localStorage.getItem(CURRENT_VENUE_ID_KEY);

export const clearCurrentVenueID = (): void =>
  window.localStorage.removeItem(CURRENT_VENUE_ID_KEY);

export const switchCurrentVenue = (venueID: string, masterVenueID: string): void => {
  if (venueID === masterVenueID) {
    window.localStorage.removeItem(CURRENT_VENUE_ID_KEY);
  } else {
    window.localStorage.setItem(CURRENT_VENUE_ID_KEY, venueID);
  }

  VENUE_SCOPED_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));

  // Full reload guarantees a clean redux + react-query state for the new profile
  window.location.reload();
};
